// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__2o_AU","selected":"Chip_selected__3M0Xo"};